import cn from './cn';
import en from './en';
import jp from './jp';
import tw from './tw';

export default {
    fallbackLocale: 'en',
    messages: {
        cn,
        en,
        jp,
        tw,
    },
};
